import ChartSettings from './ChartSettings';

export default ChartSettings;
